import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useEffect, useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useSearchParams } from 'react-router-dom';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

type SlideItemType = {
  rowSelected: number;
  kartes: any[];
  handleDeleteKartes: () => void;
  handleEditCanvas: (karteid: number) => void;
};

const SlideItem: React.FC<SlideItemType> = ({
  rowSelected,
  kartes,
  handleDeleteKartes,
  handleEditCanvas,
}) => {
  const [carouselIndex, setCarouselIndex] = useState(rowSelected);
  const carouselRef = useRef<any>();
  const [searchParams] = useSearchParams();
  const patientid = searchParams.get('id');
  // const [openDetail, setOpenDetail] = useState(false);
  // const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  // const [thumbnailSlide, setThumbnailSlide] = useState(
  //   row.records[0]?.items[0]?.thumbnail || ''
  // );
  const [openConfirm, setOpenConfirm] = useState(false);

  // const openPopover = Boolean(anchorEl);
  // const id = openPopover ? 'simple-popover' : undefined;

  // useEffect(() => {
  //   setOpenDetail(false);
  // }, [row]);

  // const handleChange = (event: any, value: any) => {
  //   setThumbnailSlide(row.records[0]?.items[value - 1]?.thumbnail || '');
  // };

  useEffect(() => {
    if (carouselRef && carouselRef.current) {
      carouselRef.current.goToSlide(rowSelected);
    }
  }, [carouselRef, rowSelected]);

  const handleCloseConfirmDelete = () => {
    setOpenConfirm(false);
  };

  const handleOpenConfirmDelete = () => {
    setOpenConfirm(true);
  };

  const handleDelete = () => {
    setOpenConfirm(false);
    const token = getToken();
    try {
      postAPI(`/karte/delete-karte?token=${token}`, {
        id: kartes[carouselIndex].karteid,
        patientid: patientid,
      }).then((res) => {
        if (res.code === 200) {
          handleDeleteKartes();
        }
      });
    } catch (error) {
      console.error('Failed to delete data:', error);
      return;
    }
  };

  const handleEdit = () => {
    handleEditCanvas(kartes[carouselIndex].karteid);
  };

  const CustomDot = ({ index, onClick, active }: any) => {
    return (
      <Box margin={'4px'}>
        <button
          onClick={(e) => {
            onClick();
            setCarouselIndex(index);
            e.preventDefault();
          }}
          style={{
            backgroundColor: 'transparent',
            border: active ? '2px solid #23B7E5' : '1px solid #F3F3F3',
          }}
        >
          {kartes &&
            kartes[index].records[0]?.items.map((image: any, index: number) => {
              return (
                <img
                  key={index}
                  src={image.thumbnail}
                  alt={image.id}
                  style={{
                    height: '75px',
                    margin: 'auto',
                    width: '100px',
                    objectFit: 'contain',
                  }}
                />
              );
            })}
        </button>
      </Box>
    );
  };

  return (
    <Box bgcolor={'primary.light'} width={'100%'}>
      <Box width={'100%'}>
        <Box>
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
            height={'56px'}
            p={'16px'}
          >
            <Stack spacing={'8px'}>
              <Typography>
                {kartes[carouselIndex] && kartes[carouselIndex].createdate}{' '}
                {kartes[carouselIndex] && kartes[carouselIndex].displayname}
              </Typography>
              <Typography fontSize={'12px'} color={'#AAB2BD'}>
                {kartes[carouselIndex] && kartes[carouselIndex].createdate}更新
              </Typography>
            </Stack>
            <Stack
              direction={'row'}
              spacing={'8px'}
              sx={{
                boxShadow: '0px 6px 12px 0px #0000001A',
                height: '40px',
                borderRadius: '4px',
                p: '8px',
              }}
            >
              <Box
                component={'img'}
                src='/images/icons/ic-search-plus.svg'
                alt='search-plus'
                sx={{ cursor: 'pointer' }}
              />
              <Box
                component={'img'}
                src='/images/icons/ic-edit.svg'
                alt='edit'
                sx={{ cursor: 'pointer' }}
                onClick={handleEdit}
              />
              <Box
                component={'img'}
                src='/images/icons/ic-plus.svg'
                alt='plus'
                sx={{ cursor: 'pointer' }}
              />
              <Box
                component={'img'}
                src='/images/icons/ic-upload.svg'
                alt='upload'
                sx={{ cursor: 'pointer' }}
              />
              <Box
                component={'img'}
                src='/images/icons/ic-setting.svg'
                alt='setting'
                sx={{ cursor: 'pointer' }}
              />
              <Box
                component={'img'}
                src='/images/icons/ic-print.svg'
                alt='print'
                sx={{ cursor: 'pointer' }}
              />
              <Box
                component={'img'}
                src='/images/icons/ic-trash.svg'
                alt='trash'
                sx={{ cursor: 'pointer' }}
                onClick={handleOpenConfirmDelete}
              />
            </Stack>
          </Stack>
        </Box>
        <Box
          width={'100%'}
          p={'16px'}
          sx={{
            '& .react-multi-carousel-dot-list ': {
              position: 'relative',
              overflow: 'auto',
              justifyContent: kartes.length > 5 ? 'flex-start' : 'center',
            },
            '& .react-multi-carousel-item': {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          }}
        >
          {kartes && (
            <Carousel
              ref={carouselRef}
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={3000}
              centerMode={false}
              className=''
              containerClass='container'
              customDot={<CustomDot />}
              dotListClass=''
              draggable
              focusOnSelect={false}
              // infinite
              itemClass=''
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={true}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1024,
                  },
                  items: 1,
                },
                mobile: {
                  breakpoint: {
                    max: 464,
                    min: 0,
                  },
                  items: 1,
                },
                tablet: {
                  breakpoint: {
                    max: 1024,
                    min: 464,
                  },
                  items: 1,
                },
              }}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots
              sliderClass=''
              slidesToSlide={1}
              swipeable
              afterChange={(previousSlide, { currentSlide }) => {
                setCarouselIndex(currentSlide);
              }}
            >
              {kartes.map((karte: any, index: number) => {
                return (
                  <img
                    key={index}
                    src={karte.records[0].items[0].thumbnail}
                    alt={karte.records[0].items[0].id}
                    style={{
                      display: 'block',
                      height: '100%',
                      margin: 'auto',
                      width: 'auto',
                    }}
                  />
                );
              })}
            </Carousel>
          )}
        </Box>
      </Box>
      <ConfirmDelete
        openConfirm={openConfirm}
        handleCloseConfirmDelete={handleCloseConfirmDelete}
        handleDelete={handleDelete}
      />
    </Box>
  );
};

export default SlideItem;
